(function(){
  var bar = document.querySelector('.tlp-bar[data-bar]');
  if(!bar) return;
  var labelEl = bar.querySelector('[data-label]'), countEl = bar.querySelector('[data-count]'),
      hintEl = bar.querySelector('[data-hint]'), nowEl = bar.querySelector('[data-now]'),
      wasEl = bar.querySelector('[data-was]'), addBtn = bar.querySelector('[data-add]'),
      toast = document.querySelector('.tlp-toast[data-toast]');
  var active = null;
  function money(n){ return '$'+n.toFixed(2); }

  function parseVariants(str){
    return (str||'').split('||').filter(Boolean).map(function(x){
      var p=x.split('::'); return { vals:(p[0]||'').split('~'), id:p[1], price:parseFloat(p[2]) };
    });
  }
  function setPreview(b,img,title){ if(img) b.pv.style.backgroundImage="url('"+img+"')"; b.pvname.textContent=title; }
  function resolveVariant(item){
    return item.variants.filter(function(v){
      for(var i=0;i<item.onames.length;i++){ if((v.vals[i]||'')!==(item.sel.vals[i]||'')) return false; }
      return true;
    })[0] || null;
  }
  function buildSelects(item){
    var html='';
    for(var i=0;i<item.onames.length;i++){
      var seen={}, vals=[];
      item.variants.forEach(function(v){ var x=v.vals[i]||''; if(x && !seen[x]){ seen[x]=1; vals.push(x); } });
      if(vals.length<1) continue;
      html+='<select data-oi="'+i+'">'+vals.map(function(x){
        return '<option value="'+x+'"'+(x===(item.sel.vals[i]||'')?' selected':'')+'>'+x+'</option>';
      }).join('')+'</select>';
    }
    return html;
  }
  function renderTray(b){
    b.tray.innerHTML='';
    for(var i=0;i<b.qty;i++){
      var item=b.selected[i];
      var slot=document.createElement('div'); slot.className='slot'+(item?' full':'');
      if(!item){ slot.innerHTML='<span class="plus">+</span> Pick a '+b.noun; }
      else {
        slot.innerHTML='<div class="chip" style="background-image:url(\''+item.img+'\')"></div>'+
          '<div class="sbody"><div class="sname">'+item.title+'</div><div class="sels">'+buildSelects(item)+'</div></div>'+
          '<button class="rm" aria-label="remove">&times;</button>';
        (function(item,slot){
          slot.querySelectorAll('select').forEach(function(se){
            se.addEventListener('change', function(){
              var oi=parseInt(this.dataset.oi,10);
              item.sel.vals[oi]=this.value;
              var v=resolveVariant(item);
              if(!v){ v=item.variants.filter(function(x){return (x.vals[oi]||'')===item.sel.vals[oi];})[0]||item.variants[0]; item.sel.vals=v.vals.slice(); }
              item.sel.id=v.id; item.sel.price=v.price; renderAll(b);
            });
          });
          slot.querySelector('.rm').addEventListener('click', function(){ toggle(b,item.btn); });
        })(item,slot);
      }
      b.tray.appendChild(slot);
    }
  }
  function renderDots(b){ var n=b.selected.length; b.dots.forEach(function(d,i){ d.classList.toggle('on', i<n); }); }
  function renderDim(b){ var full=b.selected.length>=b.qty;
    b.swatches.forEach(function(s){ s.classList.toggle('dim', full && !s.classList.contains('sel')); }); }
  function renderBar(){
    if(!active){ bar.classList.remove('show'); return; }
    var b=active, n=b.selected.length;
    bar.classList.toggle('show', n>0);
    labelEl.textContent=b.label; countEl.textContent=n+'/'+b.qty;
    var chosen=b.selected.map(function(it){return it.sel.price;});
    var sum=chosen.reduce(function(a,c){return a+c;},0);
    if(n<b.qty){
      nowEl.textContent=money(sum); wasEl.style.display='none';
      hintEl.textContent=b.mode==='bxgy' ? '— add '+(b.qty-n)+' more, cheapest is free' : '— add '+(b.qty-n)+' more to unlock $'+b.price;
      addBtn.disabled=true; addBtn.textContent=b.cta;
    } else {
      var total=b.mode==='bxgy' ? (sum-Math.min.apply(null,chosen)) : b.price;
      nowEl.textContent=money(total); wasEl.textContent=money(sum); wasEl.style.display='inline';
      hintEl.textContent=b.mode==='bxgy' ? '— cheapest is free!' : '— you saved '+money(sum-total)+'!';
      addBtn.disabled=false; addBtn.textContent=b.cta+' · '+money(total);
    }
  }
  function renderAll(b){ renderTray(b); renderDots(b); renderDim(b); active=b; renderBar(); }

  function toggle(b,btn){
    var idx=-1; b.selected.forEach(function(it,i){ if(it.btn===btn) idx=i; });
    if(idx>=0){ b.selected.splice(idx,1); btn.classList.remove('sel'); }
    else {
      if(b.selected.length>=b.qty) return;
      var vs=parseVariants(btn.dataset.variants); if(!vs.length) return;
      var onames=(btn.dataset.optnames||'').split('~').filter(Boolean);
      b.selected.push({ btn:btn, title:btn.dataset.title, img:btn.dataset.img, onames:onames, variants:vs,
        sel:{ id:vs[0].id, price:vs[0].price, vals:vs[0].vals.slice() } });
      btn.classList.add('sel'); setPreview(b, btn.dataset.img, btn.dataset.title);
    }
    renderAll(b);
  }

  function initBuilder(el){
    var b={ el:el, mode:el.dataset.mode||'fixed', qty:parseInt(el.dataset.qty,10)||3,
      price:parseFloat(el.dataset.price||'0'), noun:el.dataset.noun||'item', cta:el.dataset.cta||'Add',
      label:el.dataset.label||'Pack', init:parseInt(el.dataset.init,10)||12, discount:el.dataset.discount||'',
      pv:el.querySelector('.bb-preview .pv'), pvname:el.querySelector('.bb-preview .pvname'),
      tray:el.querySelector('.bb-tray'), dots:[].slice.call(el.querySelectorAll('.dot')),
      swatches:[].slice.call(el.querySelectorAll('.sw')), selected:[] };
    b.swatches.forEach(function(sw){
      sw.addEventListener('mouseenter', function(){ setPreview(b, sw.dataset.img, sw.dataset.title); });
      sw.addEventListener('click', function(){ toggle(b, sw); });
    });
    if(b.swatches.length>b.init){
      b.swatches.forEach(function(sw,i){ if(i>=b.init) sw.classList.add('hide'); });
      var more=document.createElement('button'); more.type='button'; more.className='bb-more';
      more.textContent='Show all '+b.swatches.length+' styles';
      el.querySelector('.bb-swatches').appendChild(more);
      more.addEventListener('click', function(){ b.swatches.forEach(function(sw){ sw.classList.remove('hide'); }); more.remove(); renderDim(b); });
    }
    if(b.swatches[0]) setPreview(b, b.swatches[0].dataset.img, b.swatches[0].dataset.title);
    renderTray(b); renderDots(b);
  }

  addBtn.addEventListener('click', function(){
    if(!active) return;
    var items=active.selected.map(function(it){ return { id:parseInt(it.sel.id,10), quantity:1 }; });
    if(items.length<active.qty) return;
    var disc = active.el && active.el.dataset ? active.el.dataset.discount : '';
    addBtn.disabled=true; addBtn.textContent='Adding…';
    fetch('/cart/add.js',{ method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ items:items }) })
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){ return disc ? fetch('/discount/'+disc).catch(function(){}) : null; })
      .then(function(){
        if(typeof window.upcartOpenCart==='function'){
          if(typeof window.upcartRefreshCart==='function'){ try{ window.upcartRefreshCart(); }catch(e){} }
          window.upcartOpenCart();
          renderBar();
        } else {
          window.location.href = disc ? '/discount/'+disc+'?redirect=/cart' : '/cart';
        }
      })
      .catch(function(){ renderBar(); if(toast){ toast.textContent='Something went wrong.'; toast.classList.add('show'); setTimeout(function(){toast.classList.remove('show');},2600);} });
  });

  document.querySelectorAll('.tlp .bb').forEach(initBuilder);

  document.querySelectorAll('.tlp a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var id=a.getAttribute('href').slice(1); var t=document.getElementById(id);
      if(t){ e.preventDefault(); t.scrollIntoView({behavior:'smooth', block:'start'}); }
    });
  });
})();
